
<button mat-raised-button [type]="type" [color]="color" [ngClass]="btnClass" [disabled]="isLoading || disabled" (click)="onBtnClick($event)">
  <div class="button-wrapper" *ngIf="!isLoading" >
    <mat-icon *ngIf="iconName" class="icon" [ngClass]="icon" matPrefix>{{iconName}}</mat-icon>
    {{label}}
    <mat-icon *ngIf="suffixIcon && !externalIcon" [ngClass]="suffixIcon" matSuffix>{{suffixIcon}}</mat-icon>
    <mat-icon *ngIf="externalIcon" [ngClass]="suffixIcon" matSuffix></mat-icon>
  </div>
  <div *ngIf="isLoading" class="lds-ellipsis"><div></div><div></div><div></div><div></div></div>
</button>